export const SANS = "'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif"

export const MEDIUM = 500

export const BOLD = 700

export const SM = 576

export const MD = 768
